import { useEffect, useRef, useState } from "react";
import styles from "./styles.module.scss";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import globalStyles from "../../../assets/styles/base/globalPage.module.scss";

const AccountingReportsDropdown = ({
  selectedTab,
  updateSelectedTab,
  otherTabs,
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const menuOption = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!menuOption.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      <div
        style={{ position: "relative", zIndex: 1 }}
        ref={menuOption}
        className={`${globalStyles.rowNavigations__item} ${
          otherTabs?.find((item) => item?.key === selectedTab)
            ? globalStyles.active
            : ""
        }`}
      >
        {/* eslint-disable-next-line */}
        <a onClick={() => setShowDropdown(!showDropdown)}>
          <div className="d-flex align-items-center">
            <FontAwesomeIcon icon="angle-down" style={{ fontSize: "16px" }} />
            <span className="default-text-size pl-2">More</span>
          </div>
        </a>
        {showDropdown ? (
          <motion.div
            initial={{ y: -10 }}
            animate={{ y: 0 }}
            className={styles.dropdown}
          >
            {otherTabs?.map((item, index) => {
              return (
                <p
                  key={index}
                  onClick={() => {
                    // updateSelectedTab(item?.key);
                    setShowDropdown(false);
                    alert("This report is coming soon!");
                  }}
                >
                  {item?.label} <span className="small">(coming soon)</span>
                </p>
              );
            })}
          </motion.div>
        ) : null}
      </div>
    </>
  );
};

export default AccountingReportsDropdown;
